import { IS_EU, IS_UK } from 'common/constants/contstants';

export const ENABLE_INVOICE_INSTRUCTIONS = IS_EU;

export const ENABLE_FINANCE_PAGE = IS_EU || IS_UK;

export const ENABLE_XML_INVOICE_FORMAT = IS_EU;

export const isGstInFieldEnable = (country?: string | null) => country === 'India';
